module.exports = __webpack_public_path__ + "img/75565.8f7c4d5b.svg";